import React from "react";
import { motion } from "framer-motion"; // For animations
import Layout from "../Layout/Layout"; // Import the enhanced Layout component

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-green-600 to-teal-500 text-white py-4 text-center shadow-inner">
      <p className="text-sm tracking-wide">
        © {new Date().getFullYear()} Smart ItBox. All rights reserved.
      </p>
    </footer>
  );
};

const ContactUs = () => {
  return (
    <Layout>
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="flex-grow w-full min-h-[calc(100vh-4rem)] py-6 px-4 sm:px-6"
      >
        <div className="bg-white/90 backdrop-blur-md shadow-2xl rounded-2xl p-6 sm:p-8 w-full max-w-3xl mx-auto border border-gray-200 transition-all">
          <h1 className="text-3xl sm:text-4xl font-bold text-center mb-8 text-[#25D366] tracking-tight font-serif">
            Contact Us
          </h1>

          <div className="flex flex-col items-center space-y-6">
            {/* Email Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="shadow-md rounded-lg p-6 w-full max-w-sm text-center bg-green-50/80 backdrop-blur-sm border border-green-200 transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
            >
              <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">
                Email Us
              </h2>
              <p className="text-sm sm:text-base text-gray-600 mb-4 font-serif">
                Feel free to send us an email:
              </p>
              <a
                href="mailto:Info@smartitbox.in"
                className="text-primary-600 font-semibold hover:underline hover:text-primary-800 transition-all"
              >
                Info@smartitbox.in
              </a>
            </motion.div>

            {/* Call Us Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="shadow-md rounded-lg p-6 w-full max-w-sm text-center bg-green-50/80 backdrop-blur-sm border border-green-200 transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
            >
              <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">
                Call Us
              </h2>
              <p className="text-sm sm:text-base text-gray-600 mb-4 font-serif">
                You can reach us by phone:
              </p>
              <a
                href="tel:+918716808360"
                className="text-primary-600 font-semibold hover:underline hover:text-primary-800 transition-all"
              >
                +91 87168 08360
              </a>
            </motion.div>
          </div>
        </div>
      </motion.main>
    </Layout>
  );
};

export default ContactUs;
